import { RefObject, useState } from 'react';
import './App.css';
import { IsInEditMode } from './EditMode';
import { getInits } from './Init';
import { MAVSearch } from './components/MAVSearch';
import { MavLocationForm } from './components/MavLocationForm';
import { MavLocationMap } from './components/MavLocationMap';
import { Heading } from './components/Util/Heading';
import { CreateMavLocationPayload } from './dtos/CreateMavLocationPayload';
import { useCreateMavLocationMutation } from './store/MavLocationMutations';
import { type Popup as PopupType } from "leaflet";
import { EditModal } from './components/EditModal';
import { MavLocation } from './dtos/MavLocation';

function App() {
  const createMavLocation = useCreateMavLocationMutation()
  const [mapRef, setMapRef] = useState<any>(null)
  const [selectedMavLocation, setSelectedMavLocation] = useState<MavLocation | null>(null)
  const popUps = new Map<string, RefObject<PopupType | null>>()

  const pointerEvents = window.PointerEvent != null;
  const webGL = !!window.WebGLRenderingContext;

  const createLocationForm = (
    <div className='pl-10 pt-10 pr-10'>
      <Heading text="Neuer Standort" />
      <MavLocationForm
        data={{ name: '', address: '', kirchengemeinde: '', mavtype: 'Erzdiözese Freiburg' }}
        onSubmit={async (data) => { await createMavLocation.mutateAsync(data) }}
      />
      <div>
        <p>Pointer Events: {pointerEvents ? 'Unterstützt' : 'Nicht Unterstützt'}</p>
        <p>WebGL: {webGL ? 'Unterstützt' : 'Nicht Unterstützt'}</p>
      </div>
      <button hidden onClick={async () => {
        const data = await getInits()
        const errors: CreateMavLocationPayload[] = []
        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          try {
            console.log(i, 'of', data.length)
            await createMavLocation.mutateAsync(element)
          } catch (error) {
            errors.push(element)
            console.error(error)
          }
        }
        console.log('failed...', errors)
      }}>Init!</button>
    </div>
  )

  return (
    <div className="App">
      <MAVSearch mapRef={mapRef} popups={popUps} setSelectedMav={setSelectedMavLocation} />
      {
        IsInEditMode() && selectedMavLocation !== null ?
          <EditModal mavLocation={selectedMavLocation} cancel={() => { setSelectedMavLocation(null) }} /> :
          <MavLocationMap setMapRef={setMapRef} popups={popUps} />
      }
      {IsInEditMode() && createLocationForm}
    </div>
  );
}

export default App;
